/**
 * Created by anthony on 10/28/14.
 */

var applicationSidebar = angular.module('applicationSidebar');
applicationSidebar.classy.controller({
    name: 'ApplicationOptionsController',
    inject: ['$scope', 'AppModelService', 'ApplicationService', 'DateService', 'ApplicationSideBarService', 'BinService', 'SliderService', 'authServiceFactory',
        'ApplicationSubcategoriesModelService', 'SchoolSubcategoriesModelService', 'BinFactory', 'BinSummaryService', 'SliderFactory', 'ResetService'],
    init: function ()
    {
        this.$.BinService = this.BinService;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.ResetService = this.ResetService;
        this.$.ApplicationSideBarService = this.ApplicationSideBarService;
        this.$.ApplicationService = this.ApplicationService;

        this.$.addCat = 0;
        this.$.bin = this.getCurrentBin();
        this.$.SubCatsLabel = {};

        angular.forEach(this.SchoolSubcategoriesModelService.get(), (value, key) => {
            this.$.SubCatsLabel[value.recordID] = value.subcategory;
        });
        this.$.isArchive = this.BinFactory.isArchive();
        this.$.categories = this.SchoolSubcategoriesModelService.get();
    },
    watch: {
        '{object}this.ApplicationService.getAwardData().app[0]': function(newValue, oldValue) {
            this.$.bin = this.getCurrentBin();
        }
    },
    getCurrentBin: function()
    {
        if (this.ApplicationService.getAwardData().app[0].Status_New == 1)
            return "Status_New";
        else if (this.ApplicationService.getAwardData().app[0].Status_Viewed == 1)
            return "Status_Viewed";
        else if (this.ApplicationService.getAwardData().app[0].Status_Consider == 1)
            return "Status_Consider";
        else if (this.ApplicationService.getAwardData().app[0].Status_Award == 1 && Number(this.ApplicationService.getAwardData().awardGiven)>0)
            return "Status_Award";
        else if (this.ApplicationService.getAwardData().app[0].Status_Reject == 1 || (this.ApplicationService.getAwardData().app[0].Status_Award == 1 && Number(this.ApplicationService.getAwardData().awardGiven)==0))
            return "Status_Reject";
    },
    nrPut: function()
    {
        var parent = this;
        this.appPut().then(function() {
            var app = parent.BinFactory.geAppByID(parent.ApplicationService.getAwardData().app[0].applicationID);
            app.NR_Choice = parent.ApplicationService.getAwardData().app[0].NR_Choice;
            parent.BinSummaryService.refresh();
        });
    },
    appPut: function()
    {
        var app = this.ApplicationService.getAwardData().app[0]
        return this.AppModelService.put(app.applicationID, app);
    },
    filterFilter: function(values)
    {
        var result = [];
        for(let t in values.values)
        {
            if (values.values[t] == true)
                result[result.length] = t;
        }
        return result;
    },
    removeCat: function(key, value)
    {
        var putObject = {subcatID: key}
        var parent = this;
        if (this.$.isArchive==false) {
            this.ApplicationSubcategoriesModelService.purge(this.ApplicationService.getAwardData().app[0].applicationID, putObject).then(function(response) {
                delete parent.ApplicationService.getAwardData().subcategories[key];
                var app = parent.BinFactory.geAppByID(parent.ApplicationService.getAwardData().app[0].applicationID);
                delete app.SubCatsFilter[key];
                for (var i = 0; i < app.CatLabel.length; i++)
                {
                    if (app.CatLabel[i] == parent.$.SubCatsLabel[key])
                        app.CatLabel.splice(i, 1);
                }
                parent.BinSummaryService.refresh();
            });
        }
    },
    addRemoveCat: function(key, value)
    {
        console.log(key);
        if (value == true) {
            var putObject = {subcatID: key}
            var parent = this;
            this.ApplicationSubcategoriesModelService.post(this.ApplicationService.getAwardData().app[0].applicationID, putObject).then(function (response) {
                parent.ApplicationService.getAwardData().subcategories[key] = true;
                var app = parent.BinFactory.geAppByID(parent.ApplicationService.getAwardData().app[0].applicationID);
                app.SubCatsFilter[key] = 1;
                app.CatLabel.push(parent.$.SubCatsLabel[key]);
                parent.BinSummaryService.refresh();
            });
        }
        else
        {
            this.removeCat(key);
        }

    },
    activeCategories: function() {
        var ret = [];
        for (var cat in this.$.categories) {
            if (this.$.categories[cat].active==1 && this.ApplicationService.getAwardData().subcategories[this.$.categories[cat].recordID])
                ret.push(this.$.categories[cat]);
        }
        return ret;
    },
    concatCategories: function(delim, start, end) {
        return this.activeCategories().slice(start, end).map(function(e) {return e.subcategory}).join(delim);
    },
    setPartial: function(partial, header, size)
    {
        this.SliderService.pushSlider(new this.SliderFactory(partial, header, size));
    }
});